import { useLocation, Link, Navigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { CheckCircle, ArrowRight, Mail, User } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_readiness-check-27/artifacts/el8npnpt_CXOlogo.png";

const PaymentSuccessPage = () => {
  const location = useLocation();
  const { username, display_username, work_email } = location.state || {};

  if (!username) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <header className="bg-white/80 backdrop-blur-xl border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-center">
          <Link to="/" data-testid="header-logo">
            <img src={LOGO_URL} alt="CodeXero" className="h-10" />
          </Link>
        </div>
      </header>

      {/* Success Content */}
      <section className="py-20">
        <div className="max-w-xl mx-auto px-6">
          <div className="bg-white border border-slate-200 rounded-sm p-10 text-center shadow-[0_4px_24px_rgba(0,51,102,0.06)]">
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <CheckCircle className="h-10 w-10 text-green-600" />
            </div>

            <h1 
              className="text-3xl font-[800] text-[#003366] mb-3"
              data-testid="success-heading"
            >
              Payment Successful!
            </h1>

            <p className="text-slate-600 mb-8" data-testid="success-message">
              Your login credentials have been sent to <span className="font-semibold">{work_email}</span>
            </p>

            <div className="bg-slate-50 border border-slate-200 rounded-sm p-6 mb-8 text-left">
              <div className="flex items-center gap-3 mb-4">
                <User className="h-5 w-5 text-[#008080]" />
                <div>
                  <p className="text-sm text-slate-500">Username</p>
                  <p className="text-lg font-[700] text-[#003366]" data-testid="display-username">
                    {display_username}
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="h-5 w-5 text-[#008080]" />
                <div>
                  <p className="text-sm text-slate-500">Credentials sent to</p>
                  <p className="text-lg font-medium text-[#003366]" data-testid="email-display">
                    {work_email}
                  </p>
                </div>
              </div>
            </div>

            <p className="text-slate-500 mb-8">
              Please check your inbox and login at{' '}
              <Link to="/login" className="font-semibold text-[#008080] underline underline-offset-2">the login page</Link>
            </p>

            <Link to="/login">
              <Button 
                data-testid="go-to-login-btn"
                className="w-full bg-[#003366] hover:bg-[#002244] text-white text-lg py-6 rounded-sm btn-hover"
              >
                Go to Login
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#003366] text-white py-8 mt-auto">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <img src={LOGO_URL} alt="CodeXero" className="h-8 brightness-0 invert mx-auto mb-4" />
          <p className="text-slate-400 text-sm">© CodeXero {new Date().getFullYear()}</p>
        </div>
      </footer>
    </div>
  );
};

export default PaymentSuccessPage;
